import { Component, Input } from '@angular/core';
import { InterestRateChangeReasonLabel, InterestRateLogData } from '../../../account.model';

@Component({
	selector: 'ifb-account-interest-rate-change-history-item',
	templateUrl: './account-interest-rate-change-history-item.component.html',
	styleUrls: ['./account-interest-rate-change-history-item.component.scss'],
	standalone: false
})
export class AccountInterestRateChangeHistoryItemComponent {
	@Input()
	entries: InterestRateLogData[];

	readonly InterestRateChangeReasonLabel = InterestRateChangeReasonLabel;
}
